module.exports = __webpack_public_path__ + "assets/img/shop_btn_end.8edd5635.png";